import { createSelector } from 'reselect';
import {
    productCurrentProductIdSelector,
    productsMainProductsSelector,
    productsProductsListSelector,
} from './productSelector';

export const pagesSubtitleSelector = (state) => state?.pages?.pageSubtitle;

export const pagesTariffsSelector = (state) => state.pages.tariffs;

export const pagesTariffsAllSelector = (state) => state.pages.tariffsAll;

export const sessionKey = (state) => state.pages.sessionKey; // #DEPRECATED https://doboard.com/1/task/28527

export const paymentPageTokenSelector = (state) => state.pages.paymentPageToken;

export const checkoutLoading = (state) => state.pages.checkoutLoading;

export const pageLoading = (state) => state.pages.isLoading;
export const paymentMenu = (state) => state.pages.paymentMenu;
export const pageCustomBills = (state) => state?.pages?.customBills ?? [];

/**
 * Is responsible for the corresponded "login" or "register" view state.
 *
 * @param state
 * @returns {boolean}
 */
export const accountFormRegisterState = (state) => state.pages.accountFormRegisterState;

/**
 * Is responsible for showing or not a login/registration form.
 *
 * @param state
 * @returns {boolean}
 */
export const accountFormIsVisible = (state) => state.pages.accountFormIsVisible;

export const proceedToCheckoutAfterAuth = (state) => state.pages.proceedToCheckoutAfterAuth;

export const pagesTariffsByProductSelector = createSelector(
    [pagesTariffsSelector, productsMainProductsSelector, (state, props) => props],
    (tariffs, currentProduct, props) => {
        if (props?.product_id) {
            return Object.values(tariffs)
                .filter((tariff) => tariff.product_id === +props.product_id)
                .reduce((acc, item) => {
                    acc[item.tariff_id] = {
                        ...item,
                        current_tariff: currentProduct?.current_tariff_id === item.tariff_id,
                    };
                    return acc;
                }, {});
        }

        return tariffs;
    }
);

export const pagesFeaturedProductsSelector = createSelector(
    [productCurrentProductIdSelector, productsProductsListSelector],
    (mainProductId, products) => {
        return products.filter((product) => product.product_id !== +mainProductId);
    }
);

export const pagesTariffsTariffSelector = (state, { tariff_id }) => state.pages.tariffs[tariff_id];

export const pagesClientSecretSelector = (state) => state.pages.clientSecret;
export const pagesClientSecretRequestSelector = (state) => state.pages.clientSecretRequest;
export const pagesShowCheckoutFormSelector = (state) => state.pages.showCheckoutForm;
export const pagesClientSecretListSelector = (state) => state.pages.clientSecretList;

export const hasPromoCodesSelector = (state) => {
    const promoCodes = state.pages.promoCodes;
    return promoCodes && Object.keys(promoCodes).length > 0;
};

export const promoCodesListSelector = (state) => {
    return state.pages.promoCodes || [];
};

export const pagesProductIdSelector = (state) => state.pages.productId;
